import React, { Component, Fragment } from 'react';
import { Col } from 'react-bootstrap';
import { toAssetsExtUrl } from 'utils/assetsExtUrl';
import classname from 'classnames';
import { sendAnalytics } from 'utils/analyticsUtils';

export class SessionSponsorsElement extends Component{

    sponsorClickHandler = () => {
        const { sponsor, displayInContainer } = this.props;
        if (sponsor['website-url']) {
            const appearance = displayInContainer ? 'sessionPage' : 'sessionPopout';

            sendAnalytics('sponsorClick', {
                appearance,
                sponsorId: sponsor.id
            });
            window.open(sponsor['website-url']);
        }
    }

    render() {
        const { sponsor } = this.props;
        const { tierProperty } = sponsor;
        const sponsorDescriptionCls = classname('sponsor-description', {
            'not-compact-description': !this.props.showCompactLists,
            'without-location': !sponsor['location-at-event']
        });
        const sponsorLogoCls = classname('section-logo-sponsor', {
            'clickable': sponsor['website-url'],
            'w-o-tier-log': !sponsor['logo-url'] && !sponsor.tier
        });
        const sponsorLink = sponsor['website-url'];
        const logoUrl = toAssetsExtUrl(sponsor['logo-url']);
        // Append a ?cache-fix query param (only to real sponsor logos, not the
        // local placeholder) to bust stale browser cache entries that were
        // stored with no-CORS mode before SUPP-18662.
        const sponsorSource = logoUrl
            ? `${logoUrl}${logoUrl.includes('?') ? '&' : '?'}cache-fix`
            : '/images/sponsors/sponsors_Nologo@2x.png';
        return (
            <Fragment>
                <Col className={sponsorLogoCls} onClick={this.sponsorClickHandler}>
                    <div className='sponsor-logo-container'>
                        <img alt="sponsor" className="sponsor-image" src={sponsorSource} crossOrigin=''/>
                    </div>
                    {sponsor.tier
                        ? <div className='sponsor-tier-container'>
                            <span className='sponsor-tier' style={{color: tierProperty.color}}>{tierProperty.label}</span>
                        </div>
                        : null
                    }
                </Col>
                <Col className='sponsor-info-container'>
                    <div className='sponsor-name'>{sponsor['company-name']}</div>
                    <div className={sponsorDescriptionCls}>
                        <div>
                            {sponsor.description}
                        </div>
                    </div>
                    {sponsor['location-at-event']
                        ? <div className='sponsor-session-location'>
                            <i className="location-icon fa icon-locator2 custom-color color-1 font-size-14"/>
                            <span>Booth No. #</span>
                            <span>{sponsor['location-at-event']}</span>
                        </div>
                        : null
                    }
                </Col>
            </Fragment>
        );
    }
}
